import { useAdmin } from '../../context/AdminContext';
import { AdminLogin } from './AdminLogin';
import { AdminDashboard } from './AdminDashboard';
import styles from './Admin.module.css';

export const Admin = () => {
  const { isLoggedIn } = useAdmin();

  return (
    <div className={styles.adminContainer}>
      {!isLoggedIn ? <AdminLogin /> : <AdminDashboard />}
    </div>
  );
};
